import React from 'react';
import '../../less/desktop';
import MenuItem from '../../views/menuItem.c';
import HoverItem from '../../views/hoverItem.c';
import { aBank24forBusiness } from "../../../../services/urls/urls";
import abankLogo from "../../img/new/abank-logo.svg"
import abankIcon from "../../img/new/abank-icon.svg"
import depositCardDesktop from "../../img/new/deposit-card-desktop.png"
import businessCardDesktop from "../../img/new/business-card-desktop.png"
import creditCardDesktop from "../../img/new/credit-card-desktop.png"
import cardsCard1Desktop from "../../img/new/cards-card-1-desktop.png"
import cardsCard2Desktop from "../../img/new/cards-card-2-desktop.png"
import cardsCard3Desktop from "../../img/new/cards-card-3-desktop.png"
import { CSSTransition } from "react-transition-group";
import DOMPurify from 'dompurify';

export default function template() {
    let { active, navigate, activeSub } = this.props;

    const {
        subMenuCards,
        subMenuCredit,
        subMenuBusiness,
        subMenuServices,
        subMenuDeposits,

        subMenuCards2,
        subMenuCredit2,
        subMenuBusiness2,
        subMenuServices2,
        subMenuDeposits2,
        subMenuServices3,
        subMenuBusiness3
    } = this.state;
 
    let subMenuItem = (val, type) => val.map(item => {
            if (item.target) {
                return <MenuItem
                    activeSub={activeSub}
                    navigate={navigate}
                    target = {item.target}
                    onClick={() => window.open(item.url, item.target)}
                    key={item.title}
                >
                    {this.l10n(item.title)}
                </MenuItem>
            }
            return <MenuItem
                activeSub={activeSub}
                toggleHover={this.toggleHover}
                alias={type}
                navigate={navigate}
                url={item.url}
                target={item.target}
                key={item.title}
            >
                {this.l10n(item.title)}
            </MenuItem>
        }
    )
      
    const loginBtn = this.props.active && this.props.active === 'business' ?
      (
        <button className="right-desktop-header-top__abank24" onClick={() => window.open(aBank24forBusiness, '_blank')}>
          <div className="right-desktop-header-top__image">
            <img src={abankIcon} alt="abank24-icon" />
          </div>
          <div className="right-desktop-header-top__text">{this.l10n('NEW_HEADER_ABUSINESS')}</div>
        </button>
      )
      : (
        <button className="right-desktop-header-top__abank24" onClick={() => window.open('https://a-bank.com.ua/services/abank', '_blank')}>
          <div className="right-desktop-header-top__image">
            <img src={abankIcon} alt="abank24-icon" />
          </div>
          <div className="right-desktop-header-top__text">{this.l10n('NEW_HEADER_ABANK24')}</div>
        </button>
      )

    return (
        <header className={`module-header-desktop ${this.state.isCollapsed ? "collapsed" : ""}`}>
            <div className="desktop-header-top">
              <div className="container">
                <div className="desktop-header-top__left left-desktop-header-top">
                    <a href="/" onClick={e => navigate('/', e)} className="left-desktop-header-top__logo">
                      <img src={abankLogo} alt="abank-logo" />
                    </a>
                    {!this.state.isCollapsed ? 
                      <div className="left-desktop-header-top__input">
                        <input type="text" onClick={() => window.open('/search', '_self')} placeholder={this.l10n('NEW_HEADER_INPUT_PLACEHOLDER')}/>
                      </div> :
                      <div className="desktop-header-bottom collapsed">
                        <HoverItem className={'title-wrap'} alias="cards" toggleHover={this.toggleHover} hover={this.state['cards']}>
                            <MenuItem
                                className={'title'}
                                active={active}
                                alias="cards"
                                navigate={navigate}
                                toggleHover={this.toggleHover}
                                url="/cards"
                                top
                            >
                                <div>{this.l10n('HEADER_LINK_CARDS')}</div>
                            </MenuItem>
                            <div className='header-menu-banners-side'>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_RECOMMENDED_PROPOSAL')}</div>
                                <div className="header-menu-banner-small">
                                    <div className='left-side'>
                                        <a id='cards-header-link-first' href="/cards/atb" style={{width: 120, height: 80}}>
                                            <img src={cardsCard1Desktop} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                                        </a>
                                    </div>
                                    <div className='right-side'>
                                        <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_ATB_TITLE')}</div>
                                        <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_ATB_SUBTITLE')}</div>
                                    </div>
                                </div>
                                <div className="header-menu-banner-small">
                                    <div className='left-side'>
                                        <a id='cards-header-link-second' href="/cards/bolt" style={{width: 120, height: 80}}>
                                            <img src={cardsCard2Desktop} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                                        </a>
                                    </div>
                                    <div className='right-side'>
                                        <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_BOLT_TITLE')}</div>
                                        <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_BOLT_SUBTITLE')}</div>
                                    </div>
                                </div>
                                <div className="header-menu-banner-small">
                                    <div className='left-side'>
                                        <a id='cards-header-link-second' href="/cards/vygoda" style={{width: 120, height: 80}}>
                                            <img src={cardsCard3Desktop} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                                        </a>
                                    </div>
                                    <div className='right-side'>
                                        <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_VYGODA_TITLE')}</div>
                                        <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_VYGODA_SUBTITLE')}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="sub-menu-item-wrapper">
                                <div style={{width: 220}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_MAIN_CARDS')}</div>
                                    {subMenuItem(subMenuCards, 'cards')}
                                </div>
                                <div style={{width: 320}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_GOV_PROGRAMS')}</div>
                                    {subMenuItem(subMenuCards2, 'cards')}
                                </div>
                            </div>
                        </HoverItem>
                        <HoverItem className={'title-wrap'} alias="deposits" toggleHover={this.toggleHover} hover={this.state['deposits']}>
                            <MenuItem
                                className={'title'}
                                active={active}
                                alias="deposits"
                                navigate={navigate}
                                toggleHover={this.toggleHover}
                                url="/deposits"
                                top
                            >
                                {this.l10n('HEADER_LINK_DEPOSIT')}
                            </MenuItem>
                            <div className="sub-menu-item-wrapper">
                                <div style={{width: 220}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_DEPOSITS_DEPOSITS')}</div>
                                    {subMenuItem(subMenuDeposits, 'deposits')}
                                </div>
                                <div style={{width: 380}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_DEPOSITS_ADDITIONAL_SERVICES')}</div>
                                    {subMenuItem(subMenuDeposits2, 'deposits')}
                                </div>
                            </div>
                            <div className='header-menu-banners-side'>
                              <a href="/deposits#frame" target={'_self'} style={{width: 400, height: 296}}>
                                <img src={depositCardDesktop} alt="header-menu-banner-big-img" style={{width: 400, height: 296}}/>
                              </a>
                            </div>
                        </HoverItem>
                        <HoverItem className={'title-wrap'} alias="credit" toggleHover={this.toggleHover} hover={this.state['credit']}>
                            <MenuItem
                                className={'title'}
                                active={active}
                                navigate={navigate}
                                toggleHover={this.toggleHover}
                                alias="credit"
                                url="/credit"
                                top
                            >
                                {this.l10n('HEADER_LINK_CREDIT')}
                            </MenuItem>
                            <div className="sub-menu-item-wrapper">
                                <div style={{width: 220}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CREDIT_ALL')}</div>
                                    {subMenuItem(subMenuCredit, 'credit')}
                                </div>
                                <div style={{width: 320}}>
                                    <div className='header-menu-subtitle' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('NEW_HEADER_CREDIT_SPECIAL_OFFERS'))}}></div>
                                    {subMenuItem(subMenuCredit2, 'credit')}
                                </div>
                            </div>
                            <div className='header-menu-banners-side'>
                              <a style={{width: 400, height: 296}} href="/credit/pbp">
                                <img src={creditCardDesktop} alt="header-menu-banner-big-img" style={{width: 400, height: 296}}/>
                              </a>
                            </div>
                        </HoverItem>
                        <HoverItem className={'title-wrap'} alias="business" toggleHover={this.toggleHover} hover={this.state['business']}>
                            <MenuItem
                                className={'title'}
                                active={active}
                                alias="business"
                                toggleHover={this.toggleHover}
                                navigate={navigate}
                                url="/business"
                                top
                            >
                                {this.l10n('HEADER_LINK_BUSINESS')}
                            </MenuItem>
                            <div className="sub-menu-item-wrapper">
                                <div style={{width: 220}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_BUSINESS_CALCULATIONS')}</div>
                                    {subMenuItem(subMenuBusiness, 'business')}
                                </div>
                                <div style={{width: 220}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_BUSINESS_FINANCING')}</div>
                                    {subMenuItem(subMenuBusiness2, 'business')}
                                </div>
                                <div style={{width: 220}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_BUSINESS_ADDITIONAL')}</div>
                                    {subMenuItem(subMenuBusiness3, 'business')}
                                </div>
                            </div>
                            <div className='header-menu-banners-side'>
                              <a style={{width: 400, height: 296}} onClick={() => window.open(aBank24forBusiness, '_blank')}>
                                <img src={businessCardDesktop} alt="header-menu-banner-big-img" style={{width: 400, height: 296}}/>
                              </a>
                            </div>
                        </HoverItem>
                        <HoverItem className={'title-wrap'} alias="services" toggleHover={this.toggleHover} hover={this.state['services']}>
                            <MenuItem
                                className={'title'}
                                active={active}
                                alias="services"
                                navigate={navigate}
                                toggleHover={this.toggleHover}
                                url="/services"
                                top
                            >
                                {this.l10n('HEADER_LINK_SERVICES')}
                            </MenuItem>
                            <div className="sub-menu-item-wrapper">
                                <div style={{width: 272}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_CLIENT_SERVICES')}</div>
                                    {subMenuItem(subMenuServices, 'services')}
                                </div>
                                <div style={{width: 320}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_DOCUMENT_SERVICES')}</div>
                                    {subMenuItem(subMenuServices2, 'services')}
                                </div>
                                <div style={{width: 320}}>
                                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_ADDITIONAL')}</div>
                                    {subMenuItem(subMenuServices3, 'services')}
                                </div>
                            </div>
                        </HoverItem>

                        <MenuItem
                            className={'title'}
                            active={active}
                            alias="contacts"
                            navigate={navigate}
                            url="/contacts"
                        >
                            {this.l10n('HEADER_LINK_CONNACTS')}
                        </MenuItem>
                        <MenuItem
                            className={'title'}
                            active={active}
                            alias="branches"
                            navigate={navigate}
                            url="/branches"
                            top
                        >
                            {this.l10n('HEADER_LINK_BRANCHES')}
                        </MenuItem>
                      </div>
                    }
                </div>
                <div className="desktop-header-top__right right-desktop-header-top">
                  {!this.state.isCollapsed ? 
                    loginBtn :
                    <div className="left-desktop-header-top__input">
                      <input type="text" onClick={() => window.open('/search', '_self')} placeholder='Пошук'/>
                    </div>
                  }
                </div>
              </div>
            </div>
            <CSSTransition in={!this.state.isCollapsed} timeout={250} classNames="fly-desktop-header-bottom" unmountOnExit>
              <div className="container desktop-header-bottom-container">
                <div className="desktop-header-bottom">
                  <HoverItem className={'title-wrap'} alias="cards" toggleHover={this.toggleHover} hover={this.state['cards']}>
                      <MenuItem
                          className={'title'}
                          active={active}
                          alias="cards"
                          navigate={navigate}
                          toggleHover={this.toggleHover}
                          url="/cards"
                          top
                      >
                          <div>{this.l10n('HEADER_LINK_CARDS')}</div>
                      </MenuItem>
                      <div className='header-menu-banners-side'>
                        <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_RECOMMENDED_PROPOSAL')}</div>
                          <div className="header-menu-banner-small">
                              <div className='left-side'>
                                  <a id='cards-header-link-first' href="/cards/atb" style={{width: 120, height: 80}}>
                                      <img src={cardsCard1Desktop} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                                  </a>
                              </div>
                              <div className='right-side'>
                                  <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_ATB_TITLE')}</div>
                                  <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_ATB_SUBTITLE')}</div>
                              </div>
                          </div>
                          <div className="header-menu-banner-small">
                              <div className='left-side'>
                                  <a id='cards-header-link-second' href="/cards/bolt" style={{width: 120, height: 80}}>
                                      <img src={cardsCard2Desktop} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                                  </a>
                              </div>
                              <div className='right-side'>
                                  <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_BOLT_TITLE')}</div>
                                  <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_BOLT_SUBTITLE')}</div>
                              </div>
                          </div>
                          <div className="header-menu-banner-small">
                              <div className='left-side'>
                                  <a id='cards-header-link-second' href="/cards/vygoda" style={{width: 120, height: 80}}>
                                      <img src={cardsCard3Desktop} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                                  </a>
                              </div>
                              <div className='right-side'>
                                  <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_VYGODA_TITLE')}</div>
                                  <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_VYGODA_SUBTITLE')}</div>
                              </div>
                          </div>
                      </div>
                      <div className="sub-menu-item-wrapper">
                          <div style={{width: 220}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_MAIN_CARDS')}</div>
                              {subMenuItem(subMenuCards, 'cards')}
                          </div>
                          <div style={{width: 320}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_GOV_PROGRAMS')}</div>
                              {subMenuItem(subMenuCards2, 'cards')}
                          </div>
                      </div>
                  </HoverItem>
                  <HoverItem className={'title-wrap'} alias="deposits" toggleHover={this.toggleHover} hover={this.state['deposits']}>
                      <MenuItem
                          className={'title'}
                          active={active}
                          alias="deposits"
                          navigate={navigate}
                          toggleHover={this.toggleHover}
                          url="/deposits"
                          top
                      >
                          {this.l10n('HEADER_LINK_DEPOSIT')}
                      </MenuItem>
                      <div className="sub-menu-item-wrapper">
                          <div style={{width: 220}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_DEPOSITS_DEPOSITS')}</div>
                              {subMenuItem(subMenuDeposits, 'deposits')}
                          </div>
                          <div style={{width: 380}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_DEPOSITS_ADDITIONAL_SERVICES')}</div>
                              {subMenuItem(subMenuDeposits2, 'deposits')}
                          </div>
                      </div>
                      <div className='header-menu-banners-side'>
                        <a href="/deposits#frame" target={'_self'} style={{width: 400, height: 296}}>
                          <img src={depositCardDesktop} alt="header-menu-banner-big-img" style={{width: 400, height: 296}}/>
                        </a>
                      </div>
                  </HoverItem>
                  <HoverItem className={'title-wrap'} alias="credit" toggleHover={this.toggleHover} hover={this.state['credit']}>
                      <MenuItem
                          className={'title'}
                          active={active}
                          navigate={navigate}
                          toggleHover={this.toggleHover}
                          alias="credit"
                          url="/credit"
                          top
                      >
                          {this.l10n('HEADER_LINK_CREDIT')}
                      </MenuItem>
                      <div className="sub-menu-item-wrapper">
                          <div style={{width: 220}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CREDIT_ALL')}</div>
                              {subMenuItem(subMenuCredit, 'credit')}
                          </div>
                          <div style={{width: 320}}>
                              <div className='header-menu-subtitle' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('NEW_HEADER_CREDIT_SPECIAL_OFFERS'))}}></div>
                              {subMenuItem(subMenuCredit2, 'credit')}
                          </div>
                      </div>
                      <div className='header-menu-banners-side'>
                        <a style={{width: 400, height: 296}} href="/credit/pbp">
                          <img src={creditCardDesktop} alt="header-menu-banner-big-img" style={{width: 400, height: 296}}/>
                        </a>
                      </div>
                  </HoverItem>
                  <HoverItem className={'title-wrap'} alias="business" toggleHover={this.toggleHover} hover={this.state['business']}>
                      <MenuItem
                          className={'title'}
                          active={active}
                          alias="business"
                          toggleHover={this.toggleHover}
                          navigate={navigate}
                          url="/business"
                          top
                      >
                          {this.l10n('HEADER_LINK_BUSINESS')}
                      </MenuItem>
                      <div className="sub-menu-item-wrapper">
                          <div style={{width: 220}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_BUSINESS_CALCULATIONS')}</div>
                              {subMenuItem(subMenuBusiness, 'business')}
                          </div>
                          <div style={{width: 220}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_BUSINESS_FINANCING')}</div>
                              {subMenuItem(subMenuBusiness2, 'business')}
                          </div>
                          <div style={{width: 220}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_BUSINESS_ADDITIONAL')}</div>
                              {subMenuItem(subMenuBusiness3, 'business')}
                          </div>
                      </div>
                      <div className='header-menu-banners-side'>
                        <a style={{width: 400, height: 296}} onClick={() => window.open(aBank24forBusiness, '_blank')}>
                          <img src={businessCardDesktop} alt="header-menu-banner-big-img" style={{width: 400, height: 296}}/>
                        </a>
                      </div>
                  </HoverItem>
                  <HoverItem className={'title-wrap'} alias="services" toggleHover={this.toggleHover} hover={this.state['services']}>
                      <MenuItem
                          className={'title'}
                          active={active}
                          alias="services"
                          navigate={navigate}
                          toggleHover={this.toggleHover}
                          url="/services"
                          top
                      >
                          {this.l10n('HEADER_LINK_SERVICES')}
                      </MenuItem>
                      <div className="sub-menu-item-wrapper">
                          <div style={{width: 272}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_CLIENT_SERVICES')}</div>
                              {subMenuItem(subMenuServices, 'services')}
                          </div>
                          <div style={{width: 320}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_DOCUMENT_SERVICES')}</div>
                              {subMenuItem(subMenuServices2, 'services')}
                          </div>
                          <div style={{width: 320}}>
                              <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_SERVICES_ADDITIONAL')}</div>
                              {subMenuItem(subMenuServices3, 'services')}
                          </div>
                      </div>
                  </HoverItem>

                  <MenuItem
                      className={'title'}
                      active={active}
                      alias="contacts"
                      navigate={navigate}
                      url="/contacts"
                  >
                      {this.l10n('HEADER_LINK_CONNACTS')}
                  </MenuItem>
                  <MenuItem
                      className={'title'}
                      active={active}
                      alias="branches"
                      navigate={navigate}
                      url="/branches"
                      top
                  >
                      {this.l10n('HEADER_LINK_BRANCHES')}
                  </MenuItem>
                </div>
              </div>
            </CSSTransition>
        </header>
    );
}
